import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
const AdminCompany = (props) => {
  const { t } = useTranslation();
  const [attributes] = useState([
    {
      type: "text",
      placeholder: "firstName",
      name: "firstName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "firstName",
      required: true,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "lastName",
      name: "lastName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "lastName",
      required: true,
      view: false,
      add: true,
      update: true,
    },
    // {
    //   type: "text",
    //   placeholder: "role",
    //   name: "role",
    //   validation: "",
    //   default: "",
    //   label: "role",
    //   required: false,
    //   view: false,
    //   add: true,
    //   update: true,
    // },
    {
      type: "text",
      placeholder: "organization",
      name: "organization",
      validation: "",
      default: "",
      label: "organization",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "city",
      name: "city",
      validation: "",
      default: "",
      label: "city",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "postalCode",
      name: "postalCode",
      validation: "",
      default: "",
      label: "postalCode",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "email",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "number",
      placeholder: "mobileNumber",
      name: "mobileNumber",
      validation: "mobile",
      default: "",
      label: "mobileNumber",
      required: false,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "industry",
      name: "industry",
      validation: "",
      default: "",
      label: "industry",
      required: false,
      view: false,
      add: true,
      update: true,
    },

    {
      type: "number",
      placeholder: "numberOfSchedule",
      name: "numberOfSchedule",
      validation: "",
      default: "",
      label: "numberOfSchedule",
      required: false,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "select",
      apiType: "API",
      selectApi: "user/countries",
      showItem: "locale",
      placeholder: "country",
      name: "country",
      search: true,
      validation: "",
      default: "",
      label: "country",
      required: false,
      filter: false,
      view: false,
      tag: true,
      add: true,
      update: true,
    },
    {
      type: "textarea",
      placeholder: "address",
      name: "address",
      validation: "",
      default: "",
      label: "address",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "select",
      placeholder: "select",
      name: "subscription",
      validation: "",
      default: "",
      label: "subscription",
      required: false,
      view: true,
      add: true,
      filter: false,
      update: true,
      apiType: "JSON",
      selectApi:[
        {id: "unlock", value: t("active")},
        {id: "lock", value: t("inactive")},
      ],
      customClass: "full"
    },
    // {
    //   type: "checkbox",
    //   placeholder: "severalCompany",
    //   name: "multipleCompanies",
    //   validation: "",
    //   showItem: "",
    //   default: "false",
    //   label: "severalCompany",
    //   required: false,
    //   view: true,
    //   tag: true,
    //   add: true,
    //   update: true,
    // },
    {
      type: "checkbox",
      placeholder: "block-company",
      name: "blocked",
      validation: "",
      showItem: "",
      default: "",
      label: "block-company",
      required: false,
      view: false,
      tag: true,
      add: false,
      update: true,
    },
  ]);
  // const [admin] = useState([
  //   {
  //     type: "text",
  //     placeholder: "firstName",
  //     name: "firstName",
  //     validation: "",
  //     default: "",
  //     label: "firstName",
  //     required: true,
  //     view: true,
  //     add: true,
  //     update: true,
  //   },
  //   {
  //     type: "text",
  //     placeholder: "lastName",
  //     name: "lastName",
  //     validation: "",
  //     default: "",
  //     label: "lastName",
  //     required: true,
  //     view: true,
  //     add: true,
  //     update: true,
  //   },

  //   {
  //     type: "text",
  //     placeholder: "mobileNumber",
  //     name: "mobileNumber",
  //     validation: "mobile",
  //     default: "",
  //     label: "mobileNumber",
  //     required: true,
  //     view: true,
  //     add: true,
  //     update: true,
  //   },
  //   {
  //     type: "text",
  //     placeholder: "email",
  //     name: "email",
  //     validation: "email",
  //     default: "",
  //     label: "email",
  //     required: true,
  //     view: true,
  //     add: true,
  //     update: true,
  //   },
  //   {
  //     type: "select",
  //     placeholder: "userType",
  //     name: "userType",
  //     validation: "",
  //     default: "",
  //     label: "userType",
  //     showItem: "title",
  //     required: false,
  //     view: true,
  //     add: true,
  //     update: true,
  //     filter: false,
  //     apiType: "API",
  //     selectApi: "user-type/select",
  //   },
  //   {
  //     type: "select",
  //     placeholder: "status",
  //     name: "status",
  //     validation: "",
  //     default: "",
  //     label: "status",
  //     required: false,
  //     view: true,
  //     add: false,
  //     filter: false,
  //     update: true,
  //     apiType: "CSV",
  //     selectApi: "Active,Inactive",
  //   },
  //   {
  //     type: "select",
  //     placeholder: "shift",
  //     name: "shiftTemplate",
  //     validation: "",
  //     showItem: "title",
  //     default: "",
  //     label: "shift",
  //     required: false,
  //     view: true,
  //     filter: false,
  //     add: true,
  //     update: true,
  //     apiType: "API",
  //     selectApi: "shift/select",
  //   },
  //   {
  //     type: "select",
  //     placeholder: "place",
  //     name: "place",
  //     validation: "",
  //     default: "",
  //     label: "place",
  //     showItem: "title",
  //     required: false,
  //     filter: false,
  //     view: true,
  //     add: true,
  //     update: true,
  //     apiType: "API",
  //     selectApi: "place/select",
  //   },
  //   {
  //     type: "invitation",
  //     placeholder: "invitation",
  //     tab: "generalInfo",
  //     name: "invitationSent",
  //     validation: "",
  //     showItem: "invitation",
  //     default: "",
  //     label: "invitation",
  //     required: true,
  //     view: false,
  //     tag: true,
  //     add: false,
  //     update: false,
  //   },
  //   {
  //     type: "checkbox",
  //     placeholder: "acceptLogin",
  //     tab: "generalInfo",
  //     name: "acceptLogin",
  //     validation: "",
  //     showItem: "",
  //     default: "",
  //     label: "acceptLogin",
  //     required: true,
  //     view: false,
  //     tag: true,
  //     add: false,
  //     update: false,
  //   },
  //   {
  //     type: "text",
  //     placeholder: "addedBy",
  //     name: "addedBy",
  //     showItem: "fullName",
  //     collection: "addedBy",
  //     validation: "",
  //     default: "",
  //     label: "addedBy",
  //     required: false,
  //     view: true,
  //     add: false,
  //     update: false,
  //   },
  // ]);
  //to update the page title
  useEffect(() => {
    document.title = `${t("company")} - Whistleblowing24`;
  }, [t]);

  // const [actions] = useState([{ element: "button", type: "subList", id: "admin", itemTitle: "firstName", icon: "admin", title: "admin", attributes: admin, params: { api: `admin`, itemTitle: "firstName", shortName: "admin", addPrivilege: true, delPrivilege: true, updatePrivilege: true, formMode: "double", datefilter: false, customClass: "medium" } }]);

  return (
    <Container className="noshadow">
      <ListTable {...props} api={`company/admin`} formMode="double" itemTitle={`organization`} shortName={`company`} addPrivilege={true} delPrivilege={false} updatePrivilege={true} attributes={attributes}></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(AdminCompany);
